import Constants from "../../../../utils/constants.js";

// ─── Formatage ───────────────────────────────────────────────────────────────

export function formatMinutes(minutes) {
    if (!minutes || minutes <= 0) return "0h";
    const h = Math.floor(minutes / 60);
    const m = Math.round(minutes % 60);
    return m > 0 ? `${h}h${String(m).padStart(2, "0")}` : `${h}h`;
}

export function minutesToDecimal(minutes) {
    if (!minutes || minutes <= 0) return 0;
    return Math.round((minutes / 60) * 100) / 100;
}

// ─── Constantes d'affichage ──────────────────────────────────────────────────

export const JOURS_LABELS = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

export const ALERTE_LABELS = {
    depassement_35h: "Dépassement 35h",
    heure_modifiee_manuellement: "Heure modifiée",
    // Alertes RH par jour (AlerteRH)
    prise_poste_sans_mouvement: "Prise de poste sans mouvement",
    fin_poste_tardive: "Fin de poste tardive",
    ecart_scan_declare_debut: "Écart scan vs déclaré (début)",
    ecart_scan_declare_fin: "Écart scan vs déclaré (fin)",
    km_anormal: "Kilométrage anormal",
    fuel_anormal: "Consommation anormale",
    idle_prolonge: "Arrêt moteur prolongé",
};

// ─── Couleurs des cases journée ──────────────────────────────────────────────

export function getCellColors(jour) {
    if (!jour || !jour.exists) return {bg: "#f5f5f5", fg: "#bbb"};
    const statutId = jour.statutJournee === "RTT" ? "Repos" : jour.statutJournee;
    const option = Constants.RH_STATUT_JOURNEE_DATA?.find(o => o.id === statutId);
    if (option) return {bg: option.color, fg: option.fontColor};
    return {bg: "#EAF3DE", fg: "#27500A"};
}

export function hasHS(jour) {
    return jour?.hsMinutes > 0 || jour?.overtimeMinutes > 0;
}

// ─── Statut global d'un opérateur ────────────────────────────────────────────

export function getStatutGlobal(semaines) {
    if (!semaines?.length) return "a_valider";
    if (semaines.some(s => s.statutValidation === "anomalie")) return "anomalie";
    if (semaines.every(s => s.statutValidation === "valide")) return "valide";
    return "a_valider";
}
